import React, { useState, useEffect, useImperativeHandle, forwardRef, useRef } from 'react';

import { SingleInput } from '../../Res/BaseInput';
import { ReqAbsenceItem } from '../../../../item/ItemContractorAttendance_RecruitmentItem_SalaryBase';

export const ContractorAttendanceDailogAbsenceAmout = forwardRef((props, ref) => {
    const [AbsenceAmout, setAbsenceAmout] = useState(0)
    const [AbsenceItems, setAbsenceItems] = useState([])
    const [hourlySalary, setHourlySalary] = useState(0)

    useEffect(() => {
        if (props.obj !== undefined && props.obj !== AbsenceItems) {
            setAbsenceAmout(props.AbsenceAmout)
            setAbsenceItems(JSON.parse(props.obj) )
            setHourlySalary(props.hourlySalary)
        }
    }, [props.obj])

    useEffect(() => {
        // console.log(props)
        // console.log(AbsenceItems)
    })

    function setAbsenceAmoutItem(absenceItem) {
        var change = false
        var amounts = 0
        AbsenceItems.forEach((item, index, arr) => {
            if (item.key === absenceItem.key) {
                arr[index] = absenceItem
                change = true
            }
            amounts += arr[index].amount
        });
        if (change) {
            // console.log(AbsenceItems)
            setAbsenceAmoutItem(JSON.parse(JSON.stringify(AbsenceItems)))
            setAbsenceAmout(amounts)
        }
    }

    useImperativeHandle(ref, () => ({
        send: () => {
            props.action({ AbsenceItems, AbsenceAmout })
        }
    }));
    return (
        <table className="table table-striped table-bordered table-hover  dataTable">
            <thead>
                <tr role="row">
                    <th className="text-center sorting col-sm-4">項目名稱</th>
                    <th className="text-right sorting col-sm-4">小時</th>
                    <th className="text-right sorting col-sm-4">金額</th>
                </tr>
                <tr role="row">
                    <td className="text-center">時薪</td>
                    <td className="text-right">1</td>
                    <td className="text-right"><span className="text-success">{Math.round(hourlySalary)}</span></td>
                </tr>
                {
                    AbsenceItems.map((absenceItem) => (
                        <DailogAbsenceAmoutItem key={absenceItem.name} absenceItem={absenceItem} hourlySalary={hourlySalary} action={setAbsenceAmoutItem} />
                    ))
                }
                <tr role="row">
                    <td className="text-center">總扣款</td>
                    <td className="text-right"></td>
                    <td className="text-right"><span className="text-success">{AbsenceAmout}</span></td>
                </tr>
            </thead>
        </table>
    )
})

function DailogAbsenceAmoutItem({ absenceItem, hourlySalary, action }) {
    const [mAbsenceItem, setAbsenceItem] = useState({})
    const [name, setName] = useState("")
    const [hours, setHours] = useState(0)
    const [proportions, setProportions] = useState()
    const [amount, setAmount] = useState(0)
    
    const [init, setInit] = useState(true)

    useEffect(() => {
        // console.log(absenceItem)
        if (absenceItem !== undefined && Object.keys(absenceItem).length !== 0 && absenceItem !== mAbsenceItem) {
            
            var item = new ReqAbsenceItem({})
            item.fromJson(absenceItem)

            setName(item.name)
            setHours(item.hours)
            setProportions(item.proportions)
            setAmount(item.amount)
            // console.log(item)
        }
    }, [absenceItem])

    useEffect(() => {
        if(init){
            setInit(false)
        }else{
            var item = Combination(absenceItem)
            action(item)
        }
    }, [hours])

    function Combination(absenceItem) {
        var item = new ReqAbsenceItem({})
        item.fromJson(absenceItem)
        item.setHourlySalary(hourlySalary)
        item.setAmount({hours})
        setAmount(item.amount)
        setAbsenceItem(JSON.parse(JSON.stringify(item)))
        return item
    }

    function inputAmount(amount){
        var item = new ReqAbsenceItem({})
        item.fromJson(absenceItem)
        item.setAmount({amount})
        setAmount(item.amount)
        setAbsenceItem(JSON.parse(JSON.stringify(item)))
        action(item)
    }

    return (

        <tr role="row">
            <td className="text-center">{name}</td>
            {proportions === undefined ?
                <>
                    <td className="text-right">
                    </td>
                    <td className="text-right">
                        <SingleInput val={amount} action={inputAmount} placeholder={176} size={12} type={"number"} isRight={true} />
                    </td>
                </>
                : <>
                    <td className="text-right">
                        <SingleInput val={hours} action={setHours} placeholder={176} size={12} type={"number"} isRight={true} />
                    </td>
                    <td className="text-right"><span className="text-success">{amount}</span></td>
                </>
            }
        </tr>
    )
}